import { render, staticRenderFns } from "./BookmarkInPage.vue?vue&type=template&id=5a54258c&"
import script from "./BookmarkInPage.vue?vue&type=script&lang=ts&"
export * from "./BookmarkInPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports